<template>
  <div class="item" :class="slideClass">
    <slot></slot>
  </div>
</template>

<script src="./Slide.js"/>
